// @generated by protoc-gen-es v2.9.0 with parameter "target=ts,import_extension=.js"
// @generated from file inventory/v1/inventory_tag_events.proto (package inventory.v1, edition 2023)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { InventoryTag, InventoryTagStatus } from "./inventory_tag_pb.js";
import { file_inventory_v1_inventory_tag } from "./inventory_tag_pb.js";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file inventory/v1/inventory_tag_events.proto.
 */
export const file_inventory_v1_inventory_tag_events: GenFile = /*@__PURE__*/
  fileDesc("CidpbnZlbnRvcnkvdjEvaW52ZW50b3J5X3RhZ19ldmVudHMucHJvdG8SDGludmVudG9yeS52MSKVAgoRSW52ZW50b3J5VGFnRXZlbnQSOQoHY3JlYXRlZBgBIAEoCzImLmludmVudG9yeS52MS5JbnZlbnRvcnlUYWdDcmVhdGVkRXZlbnRIABI5Cgd1cGRhdGVkGAIgASgLMiYuaW52ZW50b3J5LnYxLkludmVudG9yeVRhZ1VwZGF0ZWRFdmVudEgAEjkKB2RlbGV0ZWQYAyABKAsyJi5pbnZlbnRvcnkudjEuSW52ZW50b3J5VGFnRGVsZXRlZEV2ZW50SAASRgoOc3RhdHVzX2NoYW5nZWQYBCABKAsyLC5pbnZlbnRvcnkudjEuSW52ZW50b3J5VGFnU3RhdHVzQ2hhbmdlZEV2ZW50SABCBwoFZXZlbnQiTQoYSW52ZW50b3J5VGFnQ3JlYXRlZEV2ZW50EjEKDWludmVudG9yeV90YWcYASABKAsyGi5pbnZlbnRvcnkudjEuSW52ZW50b3J5VGFnIpEBChhJbnZlbnRvcnlUYWdVcGRhdGVkRXZlbnQSOgoWcHJldmlvdXNfaW52ZW50b3J5X3RhZxgBIAEoCzIaLmludmVudG9yeS52MS5JbnZlbnRvcnlUYWcSOQoVdXBkYXRlZF9pbnZlbnRvcnlfdGFnGAIgASgLMhouaW52ZW50b3J5LnYxLkludmVudG9yeVRhZyJNChhJbnZlbnRvcnlUYWdEZWxldGVkRXZlbnQSMQoNaW52ZW50b3J5X3RhZxgBIAEoCzIaLmludmVudG9yeS52MS5JbnZlbnRvcnlUYWcixAEKHkludmVudG9yeVRhZ1N0YXR1c0NoYW5nZWRFdmVudBIxCg1pbnZlbnRvcnlfdGFnGAEgASgLMhouaW52ZW50b3J5LnYxLkludmVudG9yeVRhZxI5Cg9wcmV2aW91c19zdGF0dXMYAiABKA4yIC5pbnZlbnRvcnkudjEuSW52ZW50b3J5VGFnU3RhdHVzEjQKCm5ld19zdGF0dXMYAyABKA4yIC5pbnZlbnRvcnkudjEuSW52ZW50b3J5VGFnU3RhdHVzQjdaNXBhY2thZ2VzL2JhY2tlbmQtbW9kdWxlLWludmVudG9yeS9hcGkvdjE7aW52ZW50b3J5X3YxYghlZGl0aW9uc3DoBw", [file_inventory_v1_inventory_tag]);

/**
 * @generated from message inventory.v1.InventoryTagEvent
 */
export type InventoryTagEvent = Message<"inventory.v1.InventoryTagEvent"> & {
  /**
   * @generated from oneof inventory.v1.InventoryTagEvent.event
   */
  event: {
    /**
     * @generated from field: inventory.v1.InventoryTagCreatedEvent created = 1;
     */
    value: InventoryTagCreatedEvent;
    case: "created";
  } | {
    /**
     * @generated from field: inventory.v1.InventoryTagUpdatedEvent updated = 2;
     */
    value: InventoryTagUpdatedEvent;
    case: "updated";
  } | {
    /**
     * @generated from field: inventory.v1.InventoryTagDeletedEvent deleted = 3;
     */
    value: InventoryTagDeletedEvent;
    case: "deleted";
  } | {
    /**
     * @generated from field: inventory.v1.InventoryTagStatusChangedEvent status_changed = 4;
     */
    value: InventoryTagStatusChangedEvent;
    case: "statusChanged";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message inventory.v1.InventoryTagEvent.
 * Use `create(InventoryTagEventSchema)` to create a new message.
 */
export const InventoryTagEventSchema: GenMessage<InventoryTagEvent> = /*@__PURE__*/
  messageDesc(file_inventory_v1_inventory_tag_events, 0);

/**
 * @generated from message inventory.v1.InventoryTagCreatedEvent
 */
export type InventoryTagCreatedEvent = Message<"inventory.v1.InventoryTagCreatedEvent"> & {
  /**
   * @generated from field: inventory.v1.InventoryTag inventory_tag = 1;
   */
  inventoryTag?: InventoryTag;
};

/**
 * Describes the message inventory.v1.InventoryTagCreatedEvent.
 * Use `create(InventoryTagCreatedEventSchema)` to create a new message.
 */
export const InventoryTagCreatedEventSchema: GenMessage<InventoryTagCreatedEvent> = /*@__PURE__*/
  messageDesc(file_inventory_v1_inventory_tag_events, 1);

/**
 * @generated from message inventory.v1.InventoryTagUpdatedEvent
 */
export type InventoryTagUpdatedEvent = Message<"inventory.v1.InventoryTagUpdatedEvent"> & {
  /**
   * @generated from field: inventory.v1.InventoryTag previous_inventory_tag = 1;
   */
  previousInventoryTag?: InventoryTag;

  /**
   * @generated from field: inventory.v1.InventoryTag updated_inventory_tag = 2;
   */
  updatedInventoryTag?: InventoryTag;
};

/**
 * Describes the message inventory.v1.InventoryTagUpdatedEvent.
 * Use `create(InventoryTagUpdatedEventSchema)` to create a new message.
 */
export const InventoryTagUpdatedEventSchema: GenMessage<InventoryTagUpdatedEvent> = /*@__PURE__*/
  messageDesc(file_inventory_v1_inventory_tag_events, 2);

/**
 * @generated from message inventory.v1.InventoryTagDeletedEvent
 */
export type InventoryTagDeletedEvent = Message<"inventory.v1.InventoryTagDeletedEvent"> & {
  /**
   * @generated from field: inventory.v1.InventoryTag inventory_tag = 1;
   */
  inventoryTag?: InventoryTag;
};

/**
 * Describes the message inventory.v1.InventoryTagDeletedEvent.
 * Use `create(InventoryTagDeletedEventSchema)` to create a new message.
 */
export const InventoryTagDeletedEventSchema: GenMessage<InventoryTagDeletedEvent> = /*@__PURE__*/
  messageDesc(file_inventory_v1_inventory_tag_events, 3);

/**
 * @generated from message inventory.v1.InventoryTagStatusChangedEvent
 */
export type InventoryTagStatusChangedEvent = Message<"inventory.v1.InventoryTagStatusChangedEvent"> & {
  /**
   * @generated from field: inventory.v1.InventoryTag inventory_tag = 1;
   */
  inventoryTag?: InventoryTag;

  /**
   * @generated from field: inventory.v1.InventoryTagStatus previous_status = 2;
   */
  previousStatus: InventoryTagStatus;

  /**
   * @generated from field: inventory.v1.InventoryTagStatus new_status = 3;
   */
  newStatus: InventoryTagStatus;
};

/**
 * Describes the message inventory.v1.InventoryTagStatusChangedEvent.
 * Use `create(InventoryTagStatusChangedEventSchema)` to create a new message.
 */
export const InventoryTagStatusChangedEventSchema: GenMessage<InventoryTagStatusChangedEvent> = /*@__PURE__*/
  messageDesc(file_inventory_v1_inventory_tag_events, 4);

